(function ($) {
    $.fn.solrSearch = function (args) {
        var option = $.extend({
            solrUrl: 'search.eqs.com',
            solrCore: '',
            maxResultsPerPage: 10,
            suggest: {
                enable: true,
                container: '#suggest',
                minValueLength: 4
            },
            query: '',
            solrQueryField: 'pageContent',
            solrFieldList: 'id,pageTitle,weight:score',
            hlSnippets: '3',
            hlPre: '<span class=\"highlight\">',
            hlPost: '</span>',
            highlightMultiTerm: 'true',
            hl: 'on',
            weight: 'score',
            indent: 'off',
            sort: 'score asc',

            // selectors for various HTML components
            queryFieldSelector: '[data-search-query]',
            searchButtonSelector: '[action="search"]',
            resultsContainerSelector: '[search-results]',
            resultsHeaderSelector: '[search-header]',
            resultsPaginationSelector: '[search-pagination]',


            // format basic result elements
            formatResultHeader: formatResultHeader,
            formatResultItem: formatResultItem,
            formatPagination: formatPagination
        }, args);


        // on key down it will get suggestion if suggest is true
        if (option.suggest.enable) {
            $(option.queryFieldSelector).on('keyup', function () {
                if ($(option.queryFieldSelector).val().length > (option.suggest.minValueLength - 1)) {
                    // fire query for suggestion list
                    onSuggest(true);
                } else {
                    hideSuggest();
                }
                if ($(option.queryFieldSelector).val().length == 0) {
                    flushResult();
                }
            });
        }


        var params = {};

        if (location.search) {
            var parts = location.search.substring(1).split('&');

            for (var i = 0; i < parts.length; i++) {
                var nv = parts[i].split('=');
                if (!nv[0]) continue;
                params[nv[0]] = nv[1] || true;
            }
        }

        if (typeof params.query !== "undefined" && params.query !== '') {
            option.query =  decodeURI(params.query);
        }

        if (option.query != '') {
            flushResult();
            hideSuggest();
            onSearch(true, 0, option.maxResultsPerPage, option.query);
        }


        function flushResult() {
            $(option.suggest.container).empty();
        }


        /*
         // calls solr server for suggestion via ajax (jsonp)
         */
        function onSearch(wildcard, offset, rows, query) {
            //var query = $(queryFieldSelector).val();

            if (query.length == 0) {
                return;
            }

            var wildcardSign = '';

            if (wildcard) {
                wildcardSign = '*';
            }

            var url = 'http://' + option.solrUrl + '/api/result/get';
            var q = option.solrQueryField + ':' + query + wildcardSign;

            $.post(url, {
                'solrCore': option.solrCore,
                'fl': option.solrFieldList,
                'highlightMultiTerm': option.highlightMultiTerm,
                'snippets': option.hlSnippets,
                'hl': option.hl,
                'hlFl': option.solrQueryField,
                'weight': option.weight,
                'indent': option.indent,
                'q': q,
                'start': offset,
                'rows': option.maxResultsPerPage,
                'sort': option.sort,
                'hlPre': option.hlPre,
                'hlPost': option.hlPost
            }).done(function (data) {
                onData(data, query);
            });
        }

        // ****************************************
        // Default function for creating output
        // ****************************************
        function onData(data, query) {
            data.query = query;
            //console.log(data);
            $(option.resultContainer).empty();

            // format resultHeader and append to resultContainer
            var $resultHeader = option.formatResultHeader(data);
            $(option.resultsHeaderSelector)
                .empty()
                .append($resultHeader);

            // format resultItems and append to resultContainer
            var $resultItems = [];
            for (var i = 0; i < data.response.docs.length; i++) {
                $resultItems.push(option.formatResultItem(data, i));
            }
            $(option.resultsContainerSelector)
                .empty()
                .append($resultItems);

            // format pagination items, add pagination JS functionality and add to resultsPaginationContainer
            // for now we keep the functionality of the pagination hardcoded and don't expose it via callbacks
            var $pagination = option.formatPagination(data);
            for(var pIndex = 0; pIndex < $pagination.length; pIndex++) {
                var $paginationItem = $pagination[pIndex];

                $paginationItem
                    .attr('data-offset', pIndex)
                    .on('click', function () {
                        onChangeOffset(true, $(this).attr('data-offset'), option.maxResultsPerPage, query);
                    });
            }
            $(option.resultsPaginationSelector)
                .empty()
                .append($pagination);
        }

        // ****************************************
        // Default function for creating a header for the search results
        // ****************************************
        function formatResultHeader(data) {
            var totalNumberOfResults = data.response.numFound;
            return '<div>Found ' + totalNumberOfResults + ' results for "' + data.query + '".</div>';
        }

        // ****************************************
        // Default function for creating a single result item
        // ****************************************
        function formatResultItem(data, index) {
            var doc = data.response.docs[index];
            var snippetContent = '';

            var highlights = data.highlighting[doc.id];

            if (highlights.pageContent) {
                $.each(highlights.pageContent, function (j, snippet) {
                    snippetContent = snippetContent + snippet + '<br />';
                });
            }

            var resultItem = $('<a href="' + reportURL + doc.id + '/result.html" title="' + doc.pageTitle + '"><h2>' + doc.pageTitle + '</h2><div>' + snippetContent + '</div></a>');

            return resultItem;
        }

        // ****************************************
        // Default function for creating pagination, can be overwritten with callback
        // ****************************************
        function formatPagination(data) {
            var totalNumberOfResults = data.response.numFound;
            var numberOfPages = parseInt((totalNumberOfResults / option.maxResultsPerPage) + (totalNumberOfResults %= option.maxResultsPerPage));
            console.log(numberOfPages);

            var $paginationItems = [];
            for (var page = 1; page < numberOfPages; page++) {
                $paginationItems.push($('<li><a href="#" data-offset="' + ((page - 1) * option.maxResultsPerPage) + '">' + page + '</a></li>'));
            }

            return $paginationItems;
        }


        function buildPageBrowser(totalNumberOfResults, query) {
            var numberOfPages = parseInt((totalNumberOfResults / option.maxResultsPerPage) + (totalNumberOfResults %= option.maxResultsPerPage));

            for (var page = 1; page < numberOfPages; page++) {
                $(option.pageBrowserContainer).append($('<li><a href="#" data-offset="' + ((page - 1) * option.maxResultsPerPage) + '">' + page + '</a></li>'));
            }

            $(option.pageBrowserContainer).find('li a').each(function (e) {
                var pageObj = $(this);
                pageObj.on('click', function () {
                    onChangeOffset(true, pageObj.attr('data-offset'), option.maxResultsPerPage, query);
                });

            });

        }


        function onChangeOffset(wildcard, offset, rows, query) {
            if (query.length == 0) {
                return;
            }

            var wildcardSign = '';

            if (wildcard) {
                wildcardSign = '*';
            }

            var url = 'http://' + option.solrUrl + '/api/result/get';
            var q = option.solrQueryField + ':' + query + wildcardSign;


            $.post(url, {
                'solrCore': option.solrCore,
                'fl': option.solrFieldList,
                'highlightMultiTerm': option.highlightMultiTerm,
                'snippets': option.hlSnippets,
                'hl': option.hl,
                'hlFl': option.solrQueryField,
                'weight': option.weight,
                'indent': option.indent,
                'q': q,
                'start': offset,
                'rows': option.maxResultsPerPage,
                'sort': option.sort,
                'hlPre': option.hlPre,
                'hlPost': option.hlPost
            }).done(function (data) {
                onData(data, query);
            });

            /*$.ajax({
             type: "post",
             crossDomain: true,
             dataType: "jsonp",
             callbackParameter: "1",
             success: function(data) {onData(data, query);},
             data: {'solrCore':option.solrCore, 'fl':'id,pageTitle,weight:score', 'hl.highlightMultiTerm':'true','hl.snippets':3, 'hl':'on', 'hl.fl':'pageContent', 'weight':'score', 'indent':'off', 'q':q, 'start':offset, 'rows':rows, 'sort':'score asc', 'hl.simple.pre':'<span class=\'highlight\'>', 'hl.simple.post':'</span>'},
             url: url
             });*/
        }


        function onSuggest() {

            hideSuggest();

            var query = $(option.queryFieldSelector).val().toLowerCase();

            if (query.length == 0) {
                return;
            }

            var url = 'http://' + option.solrUrl + '/api/result/terms';
            $.post(url, {
                'solrCore': option.solrCore,
                'terms': 'true',
                'termsFl': option.solrQueryField,
                'termsPrefix': query
            }).done(function (data) {
                onDataTerm(data);
            });

            /*$.ajax({
             type: "post",
             method: "post",
             crossDomain: true,
             dataType: "jsonp",
             callbackParameter: "1",
             success: function(data) {onDataTerm(data);},
             data: {'solrCore':option.solrCore, 'terms':'true', 'termsFl':option.solrQueryField, 'termsPrefix':query},
             url: url
             });*/
        }

        function onDataTerm(data) {
            $(option.suggest.container).empty();
            var json = data.terms;
            showSuggest();
            $.each(json, function (i, item) {
                for (var j = 0; j < item.length; j++) {
                    if (isInt(item[j])) {
                        continue;
                    }
                    var termItem = $('<div><span class="term">' + item[j] + '</span> <span class="term-hits">(' + item[j + 1] + ')</span></div>').prependTo($(option.suggest.container));
                    termItem.on('click', function () {
                        window.location = $(termItem).closest('form').attr('action') + '?query=' + $(this).find('.term').text();
                    });
                }
            });
        }

        function hideSuggest() {
            $(option.suggest.container).hide();
        }

        function showSuggest() {
            $(option.suggest.container).show();
        }

        /*
         // check integer values
         */
        function isInt(value) {
            var x = parseFloat(value);
            return !isNaN(value) && (x | 0) === x;
        }
    }
})(jQuery);
